// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"38d19fff","787":"f7152dd9"}[chunkId] + ".chunk.js";
};